import { render, staticRenderFns } from "./PlantTypeList.vue?vue&type=template&id=f762411a&"
import script from "./PlantTypeList.vue?vue&type=script&lang=ts&"
export * from "./PlantTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports